import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/app/global-error.tsx");
